import styled from 'styled-components'

import { cores } from '../../styles'
import { ImgPlaceholder as Image } from '../../components/LoadingCard/styles'

export const QuadroSobre = styled.div`
  color: #fff;
  background-color: ${cores.corPrincipal};
  text-align: center;
  padding: 24px;

  .sobre-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const BodyContent = styled.div`
  text-align: left;
  margin-top: 20px;
`

export const AccordionContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`

export const AccordionBtn = styled.button`
  &:not(.collapsed) {
    background-color: ${cores.corSecundaria};
    color: #fff;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`

export const AccordionPlaceholder = styled.div`
  height: 156px;
  width: 100%;

  span {
    height: 100%;
    width: 100%;
    border-radius: 8px;
  }
`

export const LogoSobre = styled.img`
  width: 45%;

  @media (min-width: 768px) {
    height: 250px;
  }

  @media (min-width: 992px) {
    height: 300px;
  }
`
